module.exports = "/images/folder-icon.svg?dac9cb62367d1180b139388ed3969f67";